import React from 'react';
import './App.css';
import CompanyCarousel from "./Carousel";
import awsExports from "./aws-exports";
import {Amplify} from 'aws-amplify'

Amplify.configure(awsExports);

function App() {
    return (
        <div className="App">
            <CompanyCarousel/>
        </div>
    );
}

export default App;
